// Toast copy for the `./ehr` launch-profile writes whose delegate dissolved at
// ARCFE-1098 (meta v1.1).
//
// THE LEGACY i18next CHANNEL, AND WHY IT IS USED HERE. The delegate resolved
// its words with `useTranslations` — the deprecated i18next hook — so there was
// no react-intl descriptor to move. Meta v1.1's `{ i18nextKey }` form carries
// the KEY instead, and `src/utils/reactQueryClient.ts` resolves it with
// `i18next.t` exactly as `src/tauri/errors/index.ts` does from non-React code.
// The key is transcribed verbatim; its English lives in
// `src/locales/en/common.json` and its translations in the sibling catalogs, so
// nothing about what a user reads changes.
//
// THIS DOES NOT COUNT AS NEW i18next USAGE, and that is a fact about the
// ratchet rather than a claim. `scripts/check-use-translations-usage.ts` counts
// the deprecated hook's CALL SITES; dissolving this delegate DELETES one, so
// the ratchet shrinks by one. A key named as data is not a call site.
//
// CONVERTING THIS TO react-intl IS A SEPARATE CHANGE, deliberately not made
// here. A descriptor needs an id, a new id has no translations behind it, and
// minting one inside a move ships untranslated copy to every non-English user
// while the diff reads as a refactor. The `@deprecated` marker on
// `ToastI18nextCopy` is where that debt is recorded.
//
// SUCCESS ONLY, AND THE ABSENCE IS THE DESIGN. The pre-move `onError` held a
// `logger.error` and NO toast; that logging moved into the package hook over
// `@heidi/runtime/logger` and no `errorToast` was added. Adding one "for
// symmetry" would put a toast in front of users where there has never been
// one, so the copy-fidelity suite asserts the silence explicitly.
//
// No `.messages.ts` basename and no `defineMessages` call: there is nothing
// here for the formatjs extractor to find. This string is owned by the Crowdin
// `common.json` pipeline, not by the react-intl one.
import type { MutationToastMeta } from '@heidi/api/meta';

export const EHR_LAUNCH_PROFILE_TOASTS = {
  deleteIntegrationEhrLaunch: {
    successToast: {
      title: { i18nextKey: 'integrations.integrationDisconnectedSuccessfully' },
    },
  },
  /**
   * LITERAL ENGLISH ON BOTH HALVES, which is meta v1.0's only form and is the
   * right one here: the pre-carve `toast(...)` call hardcoded these two strings
   * rather than reading a catalog, so there is no id and no key to carry.
   *
   * NOT CONVERTED TO A DESCRIPTOR ON THE WAY IN, for the reason the file header
   * gives about the i18next key: minting an id inside a move ships copy that no
   * catalog has yet, and the strings are not translated today either. What
   * changes for a user is nothing.
   */
  updateIntegrationEhrLaunch: {
    successToast: {
      title: 'Integration updated',
      description: 'Integration updated successfully',
    },
  },
} satisfies Record<string, MutationToastMeta>;
